import $ from 'jquery';

function handleScrollableText(container) {
    const scrollableTextContent = container.find('[data-scrollable-text-content]');
    const toggle = container.find('[data-scrollable-text-toggle]');
    const contentElement = scrollableTextContent[0];
    const toggleElement = toggle[0];

    if (!contentElement || !toggleElement) {
        return;
    }

    const collapsedHeight = Number(scrollableTextContent.data('scrollable-text-collapsed-height')) || 200;

    function updateScrollableTextState() {
        const isExpanded = container.hasClass('is-expanded');
        const hasOverflow = contentElement.scrollHeight > collapsedHeight + 1;

        container.toggleClass('is-overflowing', hasOverflow);
        toggle.prop('hidden', !hasOverflow);
        toggle.attr('aria-expanded', String(isExpanded));

        if (!hasOverflow) {
            container.removeClass('is-expanded');
            toggle.attr('aria-expanded', 'false');
        }
    }

    toggle.on('click', function () {
        if (!container.hasClass('is-overflowing')) {
            return;
        }

        container.toggleClass('is-expanded');
        toggle.attr('aria-expanded', String(container.hasClass('is-expanded')));
    });

    updateScrollableTextState();
    window.addEventListener('resize', updateScrollableTextState);
}

$(function () {
    const scrollableTextContainers = $('.scrollable-text');

    scrollableTextContainers.each(function () {
        handleScrollableText($(this));
    });
});
